import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const categories = [
  {
    title: 'Für Frauen',
    desc: 'Parfum, Schmuck & Wellness',
    image: 'https://customer-assets.emergentagent.com/job_5a103fd5-3095-43df-87fa-8511287ae247/artifacts/c69bbdr1_image.png',
    path: '/geschenke/frauen',
    emotion: 'Überrasche sie mit etwas Besonderem',
  },
  {
    title: 'Für Männer',
    desc: 'Oud, Gebetsketten & Accessoires',
    image: 'https://customer-assets.emergentagent.com/job_5a103fd5-3095-43df-87fa-8511287ae247/artifacts/6wosmjuq_image.png',
    path: '/geschenke/maenner',
    emotion: 'Ein Geschenk, das er schätzen wird',
  },
  {
    title: 'Für Kinder',
    desc: 'Bücher, Spielzeug & Überraschungen',
    image: 'https://customer-assets.emergentagent.com/job_5a103fd5-3095-43df-87fa-8511287ae247/artifacts/4o3ioo52_image.png',
    path: '/geschenke/kinder',
    emotion: 'Kinderaugen zum Leuchten bringen',
  },
  {
    title: 'Für Familien',
    desc: 'Geschenkboxen, Datteln & Deko',
    image: 'https://customer-assets.emergentagent.com/job_5a103fd5-3095-43df-87fa-8511287ae247/artifacts/x7bdty5j_image.png',
    path: '/geschenke/familien',
    emotion: 'Gemeinsam feiern, gemeinsam freuen',
  },
];

export const CategoriesSection = () => {
  return (
    <section className="py-16 md:py-24 bg-[#FDFCF8]" data-testid="categories-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="text-center mb-12">
          <span className="text-sm font-medium tracking-widest uppercase text-[#4A5D4F] mb-3 block">
            Finde das perfekte Geschenk
          </span>
          <h2 className="font-serif text-3xl md:text-4xl font-medium text-[#2C332E] mb-4">
            Geschenke nach Empfänger
          </h2>
          <p className="text-base md:text-lg text-[#6B7280] max-w-xl mx-auto">
            Für jeden jemanden Besonderen das Richtige.
          </p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.path}
              to={cat.path}
              className="group relative rounded-2xl overflow-hidden aspect-[3/4] shadow-md hover:shadow-xl transition-all hover:-translate-y-1"
              data-testid={`category-${cat.path.split('/').pop()}`}
            >
              <img src={cat.image} alt={cat.title} className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" loading="lazy" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <p className="text-xs text-white/70 mb-1">{cat.emotion}</p>
                <h3 className="font-serif text-xl font-medium text-white mb-1">{cat.title}</h3>
                <p className="text-sm text-white/80 mb-3">{cat.desc}</p>
                <span className="inline-flex items-center gap-1.5 text-sm font-medium text-[#D4C5A9] group-hover:gap-2.5 transition-all">
                  Entdecken <ArrowRight className="w-4 h-4" />
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};
